import { IAdminCalendarFilters, IAdminCalendarRequest } from '../../interfaces/admin-calendar.interface'
import {
  IAdminSalesReportRequest,
  IAdminSalesReportUpdateRequest
} from '../../interfaces/admin-sales-report.interface'
import { IAdminShopReportsRequest } from '../../interfaces/admin-shop-reports.interface'

export class GetAdminCalendarInfo {
  static readonly type = '[AdminReports] Get Admin Calendar Info'
  constructor(public payload: IAdminCalendarRequest) {}
}

export class SetAdminCalendarFilters {
  static readonly type = '[AdminReports] Set Admin Calendar Filters'
  constructor(public payload: IAdminCalendarFilters) {}
}

export class GetCountReport {
  static readonly type = '[AdminReports] Get Count Report'
  constructor(public excludeBatch: boolean) {}
}

export class GetShopWithReports {
  static readonly type = '[AdminReports] Get Shop With Reports'
  constructor(public payload: IAdminShopReportsRequest) {}
}

export class AdminGetSalesReport {
  static readonly type = '[AdminReports] Admin Get Sales Report'
  constructor(public payload: IAdminSalesReportRequest) {}
}

export class AdminGetOneDaySalesReport {
  static readonly type = '[AdminReports] Admin Get One Day Sales Report'
  constructor(public payload: IAdminSalesReportRequest) {}
}

export class AdminAddSalesReport {
  static readonly type = '[AdminReports] Admin Add Sales Report'
  constructor(public payload: IAdminSalesReportUpdateRequest) {}
}

export class AdminUpdateSalesReport {
  static readonly type = '[AdminReports] Admin Update Sales Report'
  constructor(public payload: IAdminSalesReportUpdateRequest) {}
}
